import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ArchwizardModule } from 'angular-archwizard';
import { DateTimeAdapter, OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { BsDatepickerModule, TabsModule, TooltipModule } from 'ngx-bootstrap';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale } from 'ngx-bootstrap/locale';
import { CustomDateTimeAdapter } from '../core/adapters/date-time-adapter';
import { CoreModule } from '../core/core.module';
import { SharedModule } from '../shared/shared.module';
import { UtilsModule } from '../utils/utils.module';
import { UsuariosComponent } from './Admin/Operadores/consulta/usuarios.component';
import { NuevousuarioComponent } from './Admin/Operadores/nuevos/nuevousuario.component';
import { AlertasComponent } from './alertas/alertas.component';
import { CargaMasivaComponent } from './carga-masiva/carga-masiva.component';
import { CarritoComponent } from './carrito/carrito.component';
import { ContactoComponent } from './contacto/contacto.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DetalleModuleModule } from './detalle/detalle-module.module';
import { DireccionSolicitudesComponent } from './direccion-solicitudes/direccion-solicitudes.component';
import { DireccionesComponent } from './direcciones/direcciones.component';
import { DocumentationFilesLoadComponent } from './documentation-files-load/documentation-files-load.component';
import { FormularioPlantillaComponent } from './formulario-plantilla/formulario-plantilla.component';
import { HomeLayoutComponent } from './home-layout/home-layout.component';
import { HomeModuleRoutingModule } from './home-module-routing.module';
import { InformesComponent } from './informes/informes.component';
import { UploadinformesComponent } from './informes/upload/uploadinformes.component';
import { AzDetalleComponent } from './inventariado-detalle/az-detalle/az-detalle.component';
import { ContenedorDetalleComponent } from './inventariado-detalle/contenedor-detalle/contenedor-detalle.component';
import { ExpedienteDetalleComponent } from './inventariado-detalle/expediente-detalle/expediente-detalle.component';
import { HistorialCambiosComponent } from './inventariado-detalle/historial-cambios/historial-cambios.component';
import { HistorialSolicitudesComponent } from './inventariado-detalle/historial-solicitudes/historial-solicitudes.component';
import { HistoricoFicheroComponent } from './inventariado-detalle/historico-fichero/historico-fichero.component';
import { UbicacionUnidadesDocumentalesComponent } from './inventariado-detalle/ubicacion-unidades-documentales/ubicacion-unidades-documentales.component';
import { UnidadesDocumentalesComponent } from './inventariado-detalle/unidades-documentales/unidades-documentales.component';
import { AbsorcionGrupoComponent } from './inventarios/absorcion-grupo/absorcion-grupo.component';
import { ExportacionExpedientesComponent } from './inventarios/exportacion-expedientes/exportacion-expedientes.component';
import { FiltrosAzComponent } from './inventarios/filtros-inventario/filtros-az/filtros-az.component';
import { FiltrosContenedorComponent } from './inventarios/filtros-inventario/filtros-contenedor/filtros-contenedor.component';
import { FiltrosExpedienteComponent } from './inventarios/filtros-inventario/filtros-expediente/filtros-expediente.component';
import { InventariosComponent } from './inventarios/inventarios.component';
import { AzViewerComponent } from './inventory-viewer/az-viewer/az-viewer.component';
import { ContainerViewerComponent } from './inventory-viewer/container-viewer/container-viewer.component';
import { InventoryViewerComponent } from './inventory-viewer/inventory-viewer.component';
import { RecordViewerComponent } from './inventory-viewer/record-viewer/record-viewer.component';
import { MaterialesComponent } from './materiales/materiales.component';
import { PerfilComponent } from './perfil/perfil.component';
import { ConsultaComponent } from './prestamos/consulta/consulta.component';
import { RedirectorComponent } from './redirector/redirector.component';
import { SolicitudServicioComponent } from './solicitud-servicio/solicitud-servicio.component';
import { StatisticsComponent } from './statistics/statistics.component';
import { InventoryNavigatorComponent } from './inventariado-detalle/inventory-navigator/inventory-navigator.component';
import { ValoresContainerViewerComponent } from './inventory-viewer/template-viewer/valores-container-viewer/valores-container-viewer.component';
import { TemplateViewerComponent } from './inventory-viewer/template-viewer/template-viewer.component';
import { InformeconsultasComponent } from './informes/informeconsultas/informeconsultas.component';
import { UserControlCliComponent } from './user-control-cli/user-control-cli.component';
import { InventarioSSOComponent } from './user-control-cli/inventario-sso/inventario-sso.component';
import { CargaInventariosComponent } from './carga-inventarios/carga-inventarios.component';
import { NuevaCargaComponent } from './carga-inventarios/nueva-carga/nueva-carga.component';
import { VideoInicialComponent } from './video-inicial/video-inicial.component';
import { BusquedaOficinaComponent } from './inventarios/busqueda-oficina/busqueda-oficina.component';
import { ActContenidosMasivaComponent } from './informes/act-contenidos-masiva/act-contenidos-masiva.component';
import { ChangeoptionsSolicitudComponent } from './detalle/changeoptions-solicitud/changeoptions-solicitud.component';
import { ChangeProveedorSolicitudComponent } from './detalle/change-proveedor-solicitud/change-proveedor-solicitud.component';
import { ExtraerInventariosComponent } from './inventarios/extraer-inventarios/extraer-inventarios.component';


// Locale datepicker
defineLocale('es', esLocale);


@NgModule({
  imports: [
    NgxDatatableModule,
    UtilsModule,
    HomeModuleRoutingModule,
    BsDatepickerModule,
    ArchwizardModule,
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    DetalleModuleModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    CoreModule,
    SharedModule,
    PdfViewerModule,
    NgxChartsModule,
    NgSelectModule,
    FormsModule
  ],
  declarations: [
    HomeLayoutComponent,
    DashboardComponent,
    InformesComponent,
    UploadinformesComponent,
    ConsultaComponent,
    PerfilComponent,
    DireccionesComponent,
    FormularioPlantillaComponent,
    DireccionSolicitudesComponent,
    SolicitudServicioComponent,
    UsuariosComponent,
    NuevousuarioComponent,
    CargaMasivaComponent,
    AlertasComponent,
    MaterialesComponent,
    InventariosComponent,
    ExpedienteDetalleComponent,
    HistorialSolicitudesComponent,
    HistoricoFicheroComponent,
    HistorialCambiosComponent,
    UbicacionUnidadesDocumentalesComponent,
    InventoryViewerComponent,
    CarritoComponent,
    ContactoComponent,
    FiltrosExpedienteComponent,
    FiltrosContenedorComponent,
    RecordViewerComponent,
    ContainerViewerComponent,
    ContenedorDetalleComponent,
    UnidadesDocumentalesComponent,
    AzDetalleComponent,
    FiltrosAzComponent,
    AzViewerComponent,
    DocumentationFilesLoadComponent,
    AbsorcionGrupoComponent,
    ExportacionExpedientesComponent,
    RedirectorComponent,
    StatisticsComponent,
    InventoryNavigatorComponent,
    ValoresContainerViewerComponent,
    TemplateViewerComponent,
    InformeconsultasComponent,
    UserControlCliComponent,
    InventarioSSOComponent,
    CargaInventariosComponent,
    NuevaCargaComponent,
    VideoInicialComponent,
    BusquedaOficinaComponent,
    ActContenidosMasivaComponent,
    ChangeoptionsSolicitudComponent,
    ChangeProveedorSolicitudComponent,
    ExtraerInventariosComponent
  ],
  exports: [
    VideoInicialComponent, BusquedaOficinaComponent
  ],
  providers: [
    { provide: DateTimeAdapter, useClass: CustomDateTimeAdapter }
  ],
  entryComponents: [DireccionSolicitudesComponent, CargaMasivaComponent, DocumentationFilesLoadComponent, VideoInicialComponent, BusquedaOficinaComponent, ChangeoptionsSolicitudComponent,
    ChangeProveedorSolicitudComponent]
})
export class HomeModuleModule { }
